import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientModelRestUpdatesWebSocketClass;
function ClientModelRestUpdatesWebSocket() {
  if (ClientModelRestUpdatesWebSocketClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ClientModelRestUpdatesWebSocket');
    ClientModelRestUpdatesWebSocketClass = $;
  }
  return ClientModelRestUpdatesWebSocketClass;
}
//region block: exports
export {
  ClientModelRestUpdatesWebSocket as ClientModelRestUpdatesWebSocket3jbuy8au3ubru,
};
//endregion

//# sourceMappingURL=ClientModelRestEndpoints.mjs.map
